import httpClient from "../functions/httpClient";

export interface FileMentionCandidate {
  id: string;
  name: string;
  type: "private-file" | "shared-file";
  clientId?: string | null;
  parentId?: string | null;
  path?: string;
}

export interface ClientMentionCandidate {
  id: string;
  name: string;
  entityType?: string;
}

export const fetchClientMentions = async (query: string): Promise<ClientMentionCandidate[]> => {
  const response = await httpClient(`/chat/client-mentions?q=${encodeURIComponent(query)}`) as {
    clients?: ClientMentionCandidate[];
  };
  return response.clients || [];
};

export const fetchFileMentions = async (
  query: string,
  clientId: string,
): Promise<FileMentionCandidate[]> => {
  const params = new URLSearchParams({ q: query, clientId });
  const response = await httpClient(`/chat/file-mentions?${params.toString()}`) as {
    files?: FileMentionCandidate[];
  };
  return response.files || [];
};
